// extracted by mini-css-extract-plugin
export var columnList = "_do-0";